"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.baseClassName = void 0;
exports.baseClassName = "monday-style-radio-button-component";
